import ActionType from 'constants/actions';
import APP from 'app';

const initialState = {
    fields: '',
    showAddRoom: false,
    date: {
        startDate: new Date(),
        endDate: new Date(),
        key: 'getDate'

    },
    focus: false,
    showDate: false,
    roomInfo: [],
    roomInfoLabel: '',
    showCalendar: false,
    modifyClickStatus: false,
    fsc: "true"
};

export default function searchBoxReducer(state = initialState, action) {
    try {
        const { data = '' } = action;
        switch (action.type) {
            case ActionType.SEARCHBOX.SET_CITY: {
                const {hId='' , hotelname='' , code='', cityName='' }=data
                return {
                    ...state,
                    city: cityName,
                    cId: code,
                    hid: hId,
                    hotel: hotelname
                    // removing cnid as told
                };
            }
            case ActionType.SEARCHBOX.SET_DATE: {
                return {
                    ...state,
                    date: data
                };
            }
            case ActionType.SEARCHBOX.SET_ROOM_INFO: {
                return {
                    ...state,
                    roomInfo: data
                };
            }
            case ActionType.SEARCHBOX.SET_SEARCH_FIELDS: {
                return {
                    ...state,
                    fields: data
                };
            }
            case ActionType.SEARCHBOX.SHOW_ADD_ROOM: {
                return {
                    ...state,
                    showAddRoom: data
                };
            }
            case ActionType.SEARCHBOX.SHOW_CALENDAR_FOCUS: {
                return {
                    ...state,
                    focus: data
                };
            }
            case ActionType.SEARCHBOX.SHOW_CALENDAR_OPEN: {
                return {
                    ...state,
                    showCalendar: data
                };
            }
            case ActionType.SEARCHBOX.SET_ROOM_INFO_LABEL: {
                return {
                    ...state,
                    roomInfoLabel: data
                };
            }
            case ActionType.SEARCHBOX.MODIFY_CLICK: {
                return {
                    ...state,
                    modifyClickStatus: !state.modifyClickStatus
                };
            }
            case ActionType.SEARCHBOX.SET_MORE_OPTION: {
                return {
                    ...state,
                    ...data
                };
            }
            case ActionType.SEARCHBOX.SET_DATE_INFO: {
                return {
                    ...state,
                    date: data
                };
            }

            default:
                return state;
        }
    } catch (error) {
        console.log('searchBoxReducer error >>> ', error);
        return state;
    }
}
